
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';

import { flare } from "@flareapp/flare-client";
import { flareVue } from "@flareapp/flare-vue";

if (process.env.NODE_ENV === 'production') {
    flare.light();
}

import router from './routes';
import store from './store';

import toast from './components/toast.vue';
import navbar from './views/navbar.vue';
import footer from './views/footer.vue';
import contextualizationPanel from './views/contextualization/panel.vue';
import sortableList from './components/sortableList';
import sortableItem from './components/sortableItem';
import sortableHandle from './components/sortableHandle';

import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'

/**
 * Then, we add the preloader animation 
 */

require('./preloader');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('toast', toast);
Vue.component('commemoria-navbar', navbar);
Vue.component('commemoria-footer', footer);
Vue.component('contextualization-panel', contextualizationPanel);
Vue.component('sortable-list', sortableList);
Vue.component('sortable-item', sortableItem);
Vue.component('sortable-handle', sortableHandle);
Vue.component('pdf', PDFViewer);

Vue.component('croppa', require('vue-croppa').component);

Vue.filter('nl2br', function (text) {
	return String(text).replace(/\n/g,"<br>")
});

Vue.use(flareVue);

window.Bus = new Vue();

const app = new Vue({
    el: '#app',
    router: router,
    store: store,

    created() {
    	this.$store.dispatch('fetchAccount');
    }
});